export const STATE_MAIN:string = 'main';
export const STATE_HOME:string = 'main.home';
export const STATE_HOME_PAGE:string = 'main.params';
export const STATE_ERROR_UNAUTHENTICATED:string = 'access.error';
export const STATE_ERROR_AUTHENTICATED:string = 'main.error';

export const STATE_ACCESS:string = 'access';
export const STATE_LOGIN:string = 'access.login';
export const STATE_SIGNUP:string = 'access.signup';
export const STATE_RESET_PASSWORD:string = 'access.resetpassword';
export const STATE_FORGOT_PASSWORD:string = 'access.forgotpassword';
export const STATE_CREATETICKET:string = 'access.createticket';

export const STATE_USER_PROFILE:string = 'main.userprofile';
export const STATE_USER_INFO:string = 'main.userprofile.userinfo';
export const STATE_USER_PERMISSIONS:string = 'main.userprofile.permissions';
export const STATE_USER_AUDIT:string = 'main.userprofile.audit';
export const STATE_USER_NOTIFICATIONS:string = 'main.userprofile.notifications';
export const STATE_USER_TRAINING:string = 'main.userprofile.training';

export const STATE_MAIL:string = 'mail';

export const STATE_ORDERENTRY:string = 'main.orderentry';
export const STATE_ORDERENTRY_WEBSHOP:string = 'main.orderentry.webshop';
export const STATE_ORDERENTRY_CART:string = 'main.orderentry.cart';
export const STATE_ORDERENTRY_CATALOG:string = 'main.orderentry.catalog';
export const STATE_ORDERENTRY_CATALOG_OVERVIEW:string = 'main.orderentry.catalog.overview';
export const STATE_ORDERENTRY_CATALOG_DETAIL:string = 'main.orderentry.catalog.detail';
export const STATE_ORDERENTRY_CATALOG_GUIDE:string = 'main.orderentry.catalog.guide';
export const STATE_ORDERENTRY_PAYMENT:string = 'main.orderentry.payment';
export const STATE_ORDERENTRY_CONFIRM:string = 'main.orderentry.confirm';
export const STATE_ORDERENTRY_OVERVIEW:string = 'main.orderentry.overview';
export const STATE_ORDERENTRY_ORDER_INFO:string = 'main.orderentry.orderinfo';
export const STATE_ORDERENTRY_SHIPPING:string = 'main.orderentry.shipto';
export const STATE_ORDERENTRY_INVOICE:string = 'main.orderentry.billto';
export const STATE_ORDERENTRY_CHARGES:string = 'main.orderentry.charges';
export const STATE_ORDERENTRY_DOCUMENTS:string = 'main.orderentry.documents';

export const STATE_PUNCHOUT:string = 'main.punchout';
export const STATE_PUNCHOUT_WEBSHOP:string = 'main.punchout.webshop';
export const STATE_PUNCHOUT_CART:string = 'main.punchout.cart';
export const STATE_PUNCHOUT_SHIPPING:string = 'main.punchout.shipping';
export const STATE_PUNCHOUT_CATALOG:string = 'main.punchout.catalog';
export const STATE_PUNCHOUT_CATALOG_OVERVIEW:string = 'main.punchout.catalog.overview';
export const STATE_PUNCHOUT_CATALOG_DETAIL:string = 'main.punchout.catalog.detail';

export const STATE_ORDER_CATALOG:string = 'main.catalog';
export const STATE_ORDER_CATALOG_OVERVIEW:string = 'main.catalog.overview';
export const STATE_ORDER_CATALOG_DETAIL:string = 'main.catalog.detail';
export const STATE_ORDER_ASSET:string = 'main.asset';

export const STATE_ORDER_SEARCH:string = 'main.search';

export const STATE_REPORT:string = 'main.reports';
export const STATE_DASHBOARD:string = 'main.dashboard';
export const STATE_BROWSELIST:string = 'main.browselists';
export const STATE_DASHBOARDUSAGE:string = 'main.dashboardusage';
export const STATE_BROWSELISTUSAGE:string = 'main.browselistusage';
export const STATE_DESK_OVERVIEW:string = 'main.desks';
export const STATE_CHART:string = 'main.chart';
export const STATE_CHART_BP:string = 'main.chart.bp';
export const STATE_CHART_CUSTOMER:string = 'main.chart.customer';

export const STATE_FAQ:string = 'main.faq';
export const STATE_FAQ_ITEM:string = 'main.faqitem';
export const STATE_FAQ_EDIT:string = 'main.faqedit';
export const STATE_FAQ_CREATE:string = 'main.faqcreate';
export const STATE_FAQS:string = 'main.faqs';

export const STATE_WEBSHOP:string = 'main.webshop';
export const STATE_WEBSHOPSETUP:string = 'main.webshop.setup';
export const STATE_WEBSHOPROLES:string = 'main.webshop.roles';
export const STATE_WEBSHOPMANAGEMENT:string = 'main.webshop.management';
export const STATE_GUIDEMANAGEMENT:string = 'main.webshop.management.guide';
export const STATE_ACCESSMANAGEMENT:string = 'main.webshop.management.access';
export const STATE_WEBSHOPBILLING:string = 'main.webshop.management.billing';
export const STATE_WEBSHOPSUPPLIER:string = 'main.webshop.management.supplier';
export const STATE_WEBSHOPINFO:string = 'main.webshop.management.webshopinfo';
export const STATE_WEBSHOPB2BSETTINGS:string = 'main.webshop.management.webshopb2b';

export const STATE_BPPROFILES_MAIN:string = 'main.bp';
export const STATE_BPPROFILES:string = 'main.bp.profiles';
export const STATE_BPPROFILES_CHECKLISTS:string = 'main.bp.profiles.profile-checklist';
export const STATE_BPPROFILES_TERRITORIES:string = 'main.bp.profiles.territories';
export const STATE_BPPROFILES_INVOICE:string = 'main.bp.profiles.invoice';
export const STATE_BPPROFILES_INVOICEOVERVIEW: string = 'main.bp.profiles.invoice.overview';
export const STATE_BPPROFILES_INVOICEDETAIL: string = 'main.bp.profiles.invoice.detail';
export const STATE_BPPROFILES_PRODUCTCATALOG: string = 'main.bp.profiles.productcatalog';
export const STATE_BPPROFILES_LESSORCONFIG: string  = 'main.bp.profiles.lessorconfig';
export const STATE_BPPROFILES_PLATFORMCONFIG: string  = 'main.bp.profiles.platformconfig';
export const STATE_BPPROFILES_GENERAL:string = 'main.bp.profiles.general';
export const STATE_BPPROFILES_ACSLINFO:string = 'main.bp.profiles.acsl-info';
export const STATE_BPPROFILES_MAILS:string = 'main.bp.profiles.mails';
export const STATE_BPPROFILES_TICKETS:string = 'main.bp.profiles.tickets';
export const STATE_BPPROFILES_CONTRACT:string = 'main.bp.profiles.contract';
export const STATE_BPPROFILES_BANK:string = 'main.bp.profiles.bank';
export const STATE_BPPROFILES_ACCESS_SETTINGS:string = 'main.bp.profiles.access-settings';
export const STATE_BPPROFILES_CONTACTS:string = 'main.bp.profiles.contacts';
export const STATE_BPPROFILES_OEM:string = 'main.bp.profiles.oem';
export const STATE_BPPROFILES_OEM_OVERVIEW:string = 'main.bp.profiles.oem.overview';
export const STATE_BPPROFILES_OEM_DETAIL:string = 'main.bp.profiles.oem.detail';
export const STATE_BPPROFILES_SURVEY:string = 'main.bp.profiles.survey';
export const STATE_BPPROFILES_LBDM_CHECKLIST:string = 'main.bp.profiles.lbdm-checklist';
export const STATE_BPPROFILES_ORDER_KPI:string = 'main.bp.profiles.orderkpi';
export const STATE_BPPROFILES_BP_KPI:string = 'main.bp.profiles.bpkpi';
export const STATE_BPPROFILES_LOCATIONS:string = 'main.bp.profiles.locations';
export const STATE_BPPROFILES_SLA:string = 'main.bp.profiles.sla';
export const STATE_BPPROFILES_TC:string = 'main.bp.profiles.tc';
export const STATE_BPPROFILES_VENDOR_ACCREDITATIONS:string = 'main.bp.profiles.vendor-accreditations';
export const STATE_BPPROFILES_ENGINEER_ACCREDITATIONS:string = 'main.bp.profiles.engineer-accreditations';
export const STATE_BPPROFILES_DOCUMENTS:string = 'main.bp.profiles.documents';
export const STATE_BPPROFILES_CAVEATS:string = 'main.bp.profiles.caveats';
export const STATE_BPPROFILES_AUDIT:string = 'main.bp.profiles.audit';
export const STATE_BPPROFILES_CATALOG:string = 'main.bp.profiles.catalog';
export const STATE_BPPROFILES_CATALOG_OVERVIEW:string = 'main.bp.profiles.catalog.overview';
export const STATE_BPPROFILES_CATALOG_DETAIL:string = 'main.bp.profiles.catalog.detail';
export const STATE_BPPROFILES_INTERNAL_CONFIG:string = 'main.bp.profiles.internal-config';

export const STATE_BPWIZARD:string = 'main.bp.wizard';
export const STATE_BPWIZARD_GENERAL:string = 'main.bp.wizard.general';
export const STATE_BPWIZARD_OEM:string = 'main.bp.wizard.oem';
export const STATE_BPWIZARD_COMPANYMARGIN:string = 'main.bp.wizard.margin';
export const STATE_BPWIZARD_PAYMENTTERMS:string = 'main.bp.wizard.paymentterms';
export const STATE_BPWIZARD_BILLINGMETHODS:string = 'main.bp.wizard.billing';
export const STATE_BPWIZARD_PAYMENTSOURCE:string = 'main.bp.wizard.paymentsource';
export const STATE_BPWIZARD_BANK:string = 'main.bp.wizard.bank';
export const STATE_BPWIZARD_FEES:string = 'main.bp.wizard.fees';
export const STATE_BPWIZARD_AGREEMENT:string = 'main.bp.wizard.agreement';
export const STATE_BPWIZARD_THANKYOU:string = 'main.bp.thankyou';
export const STATE_BPWIZARD_WELCOME:string = 'main.bp.welcome';

export const STATE_UPLOAD_WIZARD_STEP1:string = 'main.upload.step1';
export const STATE_UPLOAD_WIZARD_STEP2:string = 'main.upload.step2';
export const STATE_UPLOAD_WIZARD_STEP3:string = 'main.upload.step3';
export const STATE_UPLOAD_WIZARD_STEP4:string = 'main.upload.step4';

export const STATE_COMPANY:string = 'main.company';
export const STATE_COMPANYINFO:string = 'main.company.companyinfo';

export const STATE_COMPANYPROFILES:string = 'main.companyprofiles';
export const STATE_COMPANYPROFILES_INVOICETEMPLATES:string = 'main.companyprofiles.invoicetemplates';
export const STATE_COMPANYPROFILES_INVOICEOVERVIEW:string = 'main.companyprofiles.invoicetemplates.overview';
export const STATE_COMPANYPROFILES_INVOICEDETAIL:string = 'main.companyprofiles.invoicetemplates.detail';

export const STATE_PAYMENT:string = 'main.payment';
export const STATE_PAYMENT_ORDER:string = 'main.payment.order';
export const STATE_PAYMENT_INVOICE:string = 'main.payment.invoice';

export const STATE_GLOBALPRODUCT:string = 'main.globalproduct';
export const STATE_GLOBALPRODUCT_NEW:string = 'main.globalproduct.newproduct';
export const STATE_GLOBALPRODUCT_NEW_GENERAL:string = 'main.globalproduct.newproduct.general';
export const STATE_GLOBALPRODUCT_VIEW:string = 'main.globalproduct.view';
export const STATE_GLOBALPRODUCT_EDIT:string = 'main.globalproduct.edit';
export const STATE_GLOBALPRODUCT_EDIT_GENERAL:string = 'main.globalproduct.edit.general';
export const STATE_GLOBALPRODUCT_EDIT_IMAGES:string = 'main.globalproduct.edit.images';
export const STATE_GLOBALPRODUCT_EDIT_SPECS:string = 'main.globalproduct.edit.specs';


export const STATE_INVOICE:string = 'main.invoice';
export const STATE_INVOICE_ORDERFEES:string = 'main.invoice.orderfees';

export const STATE_TICKET:string = 'main.tickets';
